import lazyLoading from './lazyLoading'
import DashboardLayout from '@layouts/Dashboard'
import BusinessGuard from './guards/business-guard'

export default [
  {
    path: '/new-business/',
    component: DashboardLayout,
    beforeEnter: BusinessGuard,
    redirect: { name: 'new-business.dashboard' },
    children: [
      {
        name: 'new-business.dashboard',
        path: 'dashboard',
        component: lazyLoading('Business/NewDesign/Dashboard'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.reviews',
        path: 'reviews',
        component: lazyLoading('Business/NewDesign/Reviews'),
        // component: lazyLoading('Business/Reviews'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.employees',
        path: 'employees',
        component: lazyLoading('Business/NewDesign/Employees'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.review-landing-page',
        path: 'review-landing-page',
        component: lazyLoading('Business/NewDesign/ReviewLandingPage'),
        beforeEnter: BusinessGuard,
      },
      
      {
        name: 'new-business.review-surge',
        path: 'review-surge',        
        component: lazyLoading('Business/NewDesign/ReviewSurge'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.review-sequence',
        path: 'review-sequence',
        // component: lazyLoading('Business/Automations/Index'),
        component: lazyLoading('Business/NewDesign/ReviewSequence'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.review-images',
        path: 'review-images',
        component: lazyLoading('Business/NewDesign/ReviewImages'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.review-image-editor',
        path: 'review-image-editor/:platform',
        component: lazyLoading('Business/ReviewImageEditor'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.social-posts',
        path: 'social-posts',
        // component: lazyLoading('Business/SocialPosts'),
        component: lazyLoading('Business/NewDesign/SocialPosts'),
        beforeEnter: BusinessGuard,
      },      
      
      {
        name: 'new-business.settings',
        path: 'settings',
        component: lazyLoading('Business/NewDesign/Settings'),
        beforeEnter: BusinessGuard,
      },     
      
      {
        name: 'new-business.request-contacts',
        path: 'request-contacts',
        // component: lazyLoading('Business/RequestContacts'),
        component: lazyLoading('Business/NewDesign/Contacts'),
        beforeEnter: BusinessGuard,
      },
     
      {
        name: 'new-business.instagram-widget',
        path: 'instagram-widget',
        // component: lazyLoading('Business/InstaWidget'),
        component: lazyLoading('Business/NewDesign/InstaWidget'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.request-personalized-image',
        path: 'request-personalized-image',
        component: lazyLoading('Business/NewDesign/PersonalizedImage'),
        beforeEnter: BusinessGuard,
      },
      {
        name: 'new-business.request-review-widget',
        path: 'request-review-widget',
        component: lazyLoading('Business/NewDesign/ReviewWidget'),
        beforeEnter: BusinessGuard,
      },
      
    ],
  },
]
